import React from "react";

export const Header = () => {
  return (
    <header className="bg-alert">
      <h1>Busca recetas de bebidas</h1>
    </header>
  );
};
